import React, { Component } from 'react';
import {
    Table,
    CardBody,
    Card,
    Label,
    Col,
    Button,
    Row,ModalHeader, ModalBody, ModalFooter
} from 'reactstrap'
import { connect } from 'react-redux';
import { Preloading } from '../../components/UI/Preloader/action';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {
    publishUnpublishEWSReportRequest,
    getPublishListRequest,
    createEWSPublishRequest,
    deletePublishRequest
} from './action';
import {
    displayErrorMessage, displaySuccessMessage,
} from '../../Corporate/my-portfolio/monitoring/charts/monitoring-util';
import Modal from '../../components/UI/Modal/Modal';

const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
};

class EWSPublishUnpublish extends Component {
    state = {
        publishReportResponse: null,
        publishName: '',
        fromDate: null,
        toDate: null,
        publishModal: null,
        publishId: null,
        publishListSelectedName: null,
        publishActive: null,
        deleteModal: null,
        publishIdToDelete: null,
        publishNameToDelete: null,
    };

    componentDidMount() {
        this.props.getPublishListRequest();
    }

    componentDidUpdate(prevProps) {
        if (this.props.createPublishResponse !== prevProps.createPublishResponse) {
            this.props.preloading(false);
            if (this.props.createPublishResponse.status === "SUCCESS") {
                let statusCode = this.props.createPublishResponse.data['status'];
                if (statusCode === 200) {
                    this.setState({
                        publishName: '',
                        fromDate: null,
                        toDate: null,
                    })
                    this.props.getPublishListRequest();
                    displaySuccessMessage("EWS Publish Created Successfully!");
                } else if (statusCode === 204) {
                    displayErrorMessage("No data found to create EWS publish in given date range!")
                }
            } else {
                let message = this.props.createPublishResponse.data.message ?
                    this.props.createPublishResponse.data.message :
                    this.props.createPublishResponse.data;
                displayErrorMessage(message);
            }
        }

        if (this.props.publishReportResponse !== prevProps.publishReportResponse) {
            if (this.props.publishReportResponse.status === "SUCCESS") {
                this.props.getPublishListRequest();
                displaySuccessMessage(this.props.publishReportResponse.data.data);
            } else {
                displayErrorMessage("Please try again later!!");
            }
            this.props.preloading(false);
        }

        if (this.props.deletePublishResponse !== prevProps.deletePublishResponse) {
            if (this.props.deletePublishResponse.status === "SUCCESS") {
                this.props.getPublishListRequest();
                displaySuccessMessage('Publish deleted successfully!!');
                this.props.getPublishListRequest();
            } else {
                displayErrorMessage("Please try again later!!");
            }
            this.props.preloading(false);
        }
    }

    handlePublishNameChange = (e) => {
        this.setState({
            publishName: e.target.value,
        });
    }

    handleFromDateChange = (date) => {
        this.setState({
            fromDate: date,
        });
    }

    handleToDateChange = (date) => {
        this.setState({
            toDate: date,
        });
    }

    createEWSpublish = () => {
        this.props.preloading(true);
        this.props.createEWSPublishRequest({
            publishName: this.state.publishName,
            fromDate: moment(this.state.fromDate).format("DD-MM-YYYY"),
            toDate: moment(this.state.toDate).format("DD-MM-YYYY"),
        });
    }

    publishUnpublishEWSReport = () => {
        this.setState({ publishModal: false });
        this.props.preloading(true);
        this.props.publishUnpublishEWSReportRequest({
            publishId: this.state.publishId,
            isPublish: !this.state.publishActive,
        });
    }

    deletePublish = () => {
        this.setState({ deleteModal: false });
        this.props.preloading(true);
        this.props.deletePublishRequest({
            publishId: this.state.publishIdToDelete,
        });
    }

    togglePublishModal = (publishId, publishListSelectedName, publishActive) => {
        this.setState({
            publishModal: true,
            publishId: publishId,
            publishListSelectedName: publishListSelectedName,
            publishActive: publishActive,
        });
    }

    toggleDeleteModal = (publishId, publishName) => {
        this.setState({
            deleteModal: true,
            publishIdToDelete: publishId,
            publishNameToDelete: publishName,
        });
    }

    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0 text-center">EWS Publish/Unpublish Report</h4>
                </div>
                <Card>
                    <CardBody >
                        <Label>Create an EWS Publish</Label>
                        <Row>
                            <Col sm={8}>
                                <input
                                    placeholder={'Enter Publish Name'}
                                    type={'text'}
                                    value={this.state.publishName}
                                    onInput={toInputUppercase}
                                    className="form-control"
                                    onChange={this.handlePublishNameChange}
                                    required />
                            </Col>
                            <Col sm={5}>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.fromDate}
                                    onChange={this.handleFromDateChange}
                                    placeholderText="Enter from date"
                                    dateFormat="dd-MM-YYYY"
                                    maxDate={moment()}
                                />
                            </Col>
                            <Col sm={5}>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.toDate}
                                    onChange={this.handleToDateChange}
                                    placeholderText="Enter to date"
                                    dateFormat="dd-MM-YYYY"
                                    maxDate={moment()}
                                />
                            </Col>
                            <Col>
                                <Button
                                    color="primary"
                                    disabled={!this.state.fromDate || !this.state.toDate || !this.state.publishName}
                                    onClick={this.createEWSpublish}>
                                    Create Publish
                                </Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <br />
                <Card>
                    <CardBody>
                        <Label>Top 50 EWS Report publishes</Label>
                        <Table>
                            <thead style={{ textAlign: "center" }}>
                                <tr>
                                    <th>#</th>
                                    <th>Publish Name</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Publish Status</th>
                                    <th>Publish/Unpublish</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody style={{ textAlign: "center" }}>
                                {this.props.publishList.data && this.props.publishList.data.length > 0 &&
                                    this.props.publishList.data.map((obj, index) => <tr key={obj.id}>
                                        <th scope="row">{index + 1}</th>
                                        <td>{obj.publishName}</td>
                                        <td>{obj.fromDate}</td>
                                        <td>{obj.toDate}</td>
                                        <td><i className="fa fa-circle" style={{ color: obj.active ? 'green' : 'red' }}></i></td>
                                        <td title={obj.active ? 'Unpublish Report' : 'Publish Report'}>
                                            <Button
                                                color='primary'
                                                onClick={() => this.togglePublishModal(obj.id, obj.publishName, obj.active)}>
                                                {obj.active ? <i className="fa fa-undo"></i> : <i className="fa fa-paper-plane"></i>}
                                            </Button>
                                        </td>
                                        <td title='Delete Publish'>
                                            <Button
                                                color='primary'
                                                onClick={() => this.toggleDeleteModal(obj.id, obj.publishName)}>
                                                <i className="fa fa-trash"></i>
                                            </Button>
                                        </td>
                                    </tr>)}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>

                {/* Publish Modal */}
                <Modal show={this.state.publishModal} className='Modal shadow-none cp-upload-modal' >
                    <ModalHeader className="label-text-center">Publish / Unpublish Report</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Label className="label-text-center">
                            {this.state.publishActive
                                ? `Do You Wish To Proceed With Unpublishing The Report : ${this.state.publishListSelectedName}?`
                                : `Do You Wish To Proceed With Publishing The Report : ${this.state.publishListSelectedName}?`
                            }
                            </Label>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({ publishModal: false })}>Close</Button>
                        <Button color="primary" onClick={this.publishUnpublishEWSReport}>Confirm</Button>
                    </ModalFooter>
                </Modal>

                {/* Delete Publish Modal */}
                <Modal show={this.state.deleteModal} className='Modal shadow-none cp-upload-modal' >
                    <ModalHeader className="label-text-center">Delete Report</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Label className="label-text-center">
                                Do You Wish To Proceed With Deleting The Report : {this.state.publishNameToDelete} ?
                            </Label>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({ deleteModal: false })}>Close</Button>
                        <Button color="primary" onClick={this.deletePublish}>Confirm</Button>
                    </ModalFooter>
                </Modal>
            </Col>
        )
    }
}

const mapStateToProps = (state) => ({
    publishReportResponse: state.ews.publishReportResponse,
    createPublishResponse: state.ews.createPublishResponse,
    publishList: state.ews.publishListResponse,
    deletePublishResponse: state.ews.deletePublishResponse,
})

const mapDispatchToProps = (dispatch) => ({
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    publishUnpublishEWSReportRequest: (data) => { dispatch(publishUnpublishEWSReportRequest(data)) },
    createEWSPublishRequest: (data) => { dispatch(createEWSPublishRequest(data)) },
    getPublishListRequest: (data) => { dispatch(getPublishListRequest(data)) },
    deletePublishRequest: (data) => { dispatch(deletePublishRequest(data)) }
});

export default connect(mapStateToProps, mapDispatchToProps)(EWSPublishUnpublish);